import { useCallback } from 'react';

/**
 * จัดการ list ของ Client ID (เพิ่ม/แก้/ลบ) ที่ใช้ตอนเลือก "RA ต้องอนุมัติคนเข้าองค์กร"
 * เดิม logic นี้ (handleInputChange, removeInputField, ปุ่มเพิ่ม) ซ้ำกันเป๊ะทั้งใน
 * CreatePortal.jsx และ EditPortal.jsx
 *
 * @param {string[]} clientIDList - state ปัจจุบัน (มาจาก Redux)
 * @param {(next: string[]) => void} setClientIDList - setter (dispatch wrapper จาก Redux)
 */
export const useClientIdList = (clientIDList, setClientIDList) => {
    const updateField = useCallback(
        (index, value) => {
            const updated = [...clientIDList];
            updated[index] = value;
            setClientIDList(updated);
        },
        [clientIDList, setClientIDList]
    );

    const removeField = useCallback(
        (index) => {
            const updated = [...clientIDList];
            updated.splice(index, 1);
            setClientIDList(updated);
        },
        [clientIDList, setClientIDList]
    );

    const addField = useCallback(() => {
        setClientIDList([...clientIDList, '']);
    }, [clientIDList, setClientIDList]);

    return { updateField, removeField, addField };
};